// frontend/src/components/columns/DegreeAuditColumn.tsx

import HierarchicalDegreeAudit from '../DegreeAudit/HierarchicalDegreeAudit';
import type { AcademicPlan, EnrolledCourse } from '../../types';

const SHOW_DEBUG_INFO = false;

export interface DegreeAuditColumnProps {
  hasAcademicPlan?: boolean;
  academicPlan?: (AcademicPlan & { id?: number | null }) | null;
  onAddToSemester?: (course: EnrolledCourse) => void;
  onToggleBookmark?: (course: EnrolledCourse) => void;
  onAddCourseToPlan?: (course: EnrolledCourse, semester: string) => Promise<void> | void;
  onChangeRequirement?: (course: unknown) => void;
  courseRequirements?: Record<string, string[]>;
  openDropdownId?: string | null;
  setOpenDropdownId?: (id: string) => void;
  chatDebugInfo?: unknown;
  onManageSemesters?: () => void;
  onDismissSetup?: () => void;
}

/**
 * Left-column degree audit view. Thin wrapper around HierarchicalDegreeAudit.
 */
export function DegreeAuditColumn({
  hasAcademicPlan,
  academicPlan,
  onAddToSemester,
  onToggleBookmark,
  onAddCourseToPlan,
  onChangeRequirement,
  courseRequirements,
  openDropdownId,
  setOpenDropdownId,
  chatDebugInfo,
  onManageSemesters,
  onDismissSetup,
}: DegreeAuditColumnProps = {}) {
  // HierarchicalDegreeAudit's typed surface is narrow; the column historically
  // forwarded extra drag/dropdown/handler props for downstream consumers. Cast
  // through `unknown` so TS doesn't complain about the wider passthrough.
  const Audit = HierarchicalDegreeAudit as unknown as React.ComponentType<Record<string, unknown>>;

  return (
    <div className="relative h-full overflow-auto px-2 pr-2 lg:pr-4">
      <Audit
        hasAcademicPlan={hasAcademicPlan}
        academicPlan={academicPlan}
        onAddToSemester={onAddToSemester}
        onToggleBookmark={onToggleBookmark}
        onAddCourseToPlan={onAddCourseToPlan}
        onChangeRequirement={onChangeRequirement}
        courseRequirements={courseRequirements}
        openDropdownId={openDropdownId}
        setOpenDropdownId={setOpenDropdownId}
        chatDebugInfo={SHOW_DEBUG_INFO ? chatDebugInfo : undefined}
        onManageSemesters={onManageSemesters}
        onDismissSetup={onDismissSetup}
      />
    </div>
  );
}
